export { default as TestimonialsStyle } from './Testimonials.module.scss';
